module.exports = __webpack_public_path__ + "media/fr_fr_s2_Maurice.1b469bd1.oga";